module.exports = __webpack_public_path__ + "img/my_user.0eaaad38.svg";